import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import Heading from "../../components/Heading";
import SetListContent from "../../components/setList/SetListContent";
import Paper from "@material-ui/core/Paper";
import { Tooltip, IconButton, Typography } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

const helpText = (
    <div style={{ padding: 8, maxWidth: 300 }}>
        <p style={{ margin: "0 0 8px 0" }}>
            Use this section to create your set lists. You can create as many set lists as you like. These set lists will be able to be distributed to your band members for any booked gig.
        </p>
        <p style={{ margin: 0 }}>
            <strong>Tip:</strong> You can drag and drop songs to reorder the set list.
        </p>
    </div>
);

@inject("songListStore", "profileStore", "setListStore")
@observer
class SetList extends Component {
    state = {
        openAdd: false,
        openRemove: false
    };

    componentDidMount() {
        // const { currentProfile } = this.props.profileStore;
        // this.props.setListStore.setProfileId(currentProfile.id);
    }

    handleSnackbarAddClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        this.setState({ openAdd: false });
    };

    handleSnackbarDeleteClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        this.props.songListStore.executeDeleteSongs();
        this.setState({ openDelete: false });
    };

    render() {
        const { currentProfile } = this.props.profileStore;

        return (
            <main>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Heading title="My Set Lists" />
                    <Paper style={{ padding: 16 }}>
                        <div style={{ display: "flex", alignItems: "center", marginBottom: 16 }}>
                            <Typography variant="headline" component="h3">
                                Set Lists
                            </Typography>
                            <Tooltip title={helpText} placement="bottom-start" interactive>
                                <IconButton style={{ marginLeft: 8, padding: 4 }}>
                                    <HelpOutlineIcon style={{ color: "#555" }} />
                                </IconButton>
                            </Tooltip>
                        </div>
                        {currentProfile && <SetListContent type="musician" profileId={currentProfile.id} />}
                    </Paper>
                </MainContainer>
            </main>
        );
    }
}

export default SetList;
